import type { Exact, PriceRankItem, RoomPriceRankGetNewPriceRankItemQuery } from "@/lib/gql/__generated__/graphql";

import { Button } from "@/components/ui/button/button";

import { RoomPriceRankListItem } from "./components";
import { useRoomPriceRankList } from "./hooks";

import type { ProductRoomPriceRankFormModel } from "../../../model/price-rank-and-daily-status/_shared/price-rank/type";
import type { ProductRoomPriceRankOnSetViewModelType } from "../../../model/price-rank-and-daily-status/_shared/price-rank/use-case/use-room-price-rank-model";
// eslint-disable-next-line import/no-restricted-paths
import type { ApolloQueryResult } from "@apollo/client";

type Props = {
	roomPriceRankMast: ProductRoomPriceRankFormModel["ViewModel"];
	onSetRoomPriceRankMast: ProductRoomPriceRankOnSetViewModelType;

	fetchNewPriceRankItem: (
		variables?:
			| Partial<
					Exact<{
						hotelID: string;
					}>
			  >
			| undefined,
	) => Promise<ApolloQueryResult<RoomPriceRankGetNewPriceRankItemQuery | undefined>>;

	selectedPriceRank: PriceRankItem | undefined;
	onSetSelectedPriceRank: (input: PriceRankItem) => void;
};

export const RoomPriceRankList = ({
	roomPriceRankMast,
	onSetRoomPriceRankMast,
	fetchNewPriceRankItem,
	selectedPriceRank,
	onSetSelectedPriceRank: _onSetSelectedPriceRank,
}: Props) => {
	const {
		onSetPriceRankColor,
		onSetPriceRankName,
		onSetIsStopSelling,

		appendPriceRank,
		removePriceRank,

		onSetSelectedPriceRank,

		onSetPriceAmount,

		onSetRoomPriceRankItem,
	} = useRoomPriceRankList({
		fetchNewPriceRankItem,
		roomPriceRankMast,
		onSetRoomPriceRankMast,
		onSetSelectedPriceRank: _onSetSelectedPriceRank,
	});

	return (
		<div className="flex max-w-2xl flex-1 flex-col gap-y-10">
			<div className="flex flex-col gap-y-8">
				{roomPriceRankMast.ranks.value.length ? (
					roomPriceRankMast.ranks.value.map((rank, idx) => {
						const key = rank.priceRankID.value;

						return (
							<RoomPriceRankListItem
								onSetSelectedPriceRank={() => onSetSelectedPriceRank(rank)}
								priceRankItem={rank}
								key={key}
								selectedPriceRank={selectedPriceRank}
								onSetPriceRankColor={onSetPriceRankColor(idx, rank)}
								onSetPriceRankName={onSetPriceRankName(idx, rank)}
								onSetIsStopSelling={onSetIsStopSelling(idx, rank)}
								removePriceRank={removePriceRank(idx)}
								onSetPriceAmount={onSetPriceAmount(idx, rank)}
								onSetRoomPriceRankItem={onSetRoomPriceRankItem(idx)}
							/>
						);
					})
				) : (
					<div>
						<p>料金ランクがありません</p>
					</div>
				)}
			</div>
			<div>
				<Button onClick={appendPriceRank} variant="outline" type="button">
					料金ランクを追加
				</Button>
			</div>
		</div>
	);
};

RoomPriceRankList.displayName = "RoomPriceRankList";
